<template>
	<div class="auth register">
		<h1>{{ $t('base.auth.signup') }}</h1>
		<form @submit.prevent="validateAndSubmit" class="form-auth">
			<input-text v-model="model.fullname" name="login_fullname" :placeholder="$t('labels.auth.fullname')" rules="required|alpha_spaces"/>
			<input-text v-model="model.email" name="login_email" :placeholder="$t('labels.auth.email')" rules="required|email"/>
			<input-password v-model="model.password" name="password" :placeholder="$t('labels.auth.password')" rules="required|min:8"/>
			<input-password v-model="model.confirm_password" name="confirm_password" :placeholder="$t('labels.auth.confirm_password')" :rules="'required|confirmed:'+model.password"/>
			<error-box v-if="form_error" :error="form_error"/>
			<button type="submit" class="btn btn-round btn-primary">{{ $t('buttons.auth.create_account') }}</button>
		</form>
	</div>
</template>

<script>
export default {
	props: [
		'email',
		'invitation_id'
	],
	data () {
		return {
			model: {
				fullname: '',
				email: '',
				password: '',
				confirm_password: ''
			},
			form_error: null
		}
	},
	methods: {
		validateAndSubmit () {
			this.$validator.validateAll().then(result => {
				if (result) this.submit()
			})
		},
		submit () {
			const credentials = {
				fullname: this.model.fullname,
				email: this.model.email,
				password: this.model.password,
				invitation_id: this.invitation_id
			}
			this.$api.auth.registerWithInvitation(this, credentials)
				.then(response => {
					this.$log.info('user register', 'auth.registerWithInvitation OK', response)()
					this.$router.push({ name: 'AuthLogin' })
				})
				.catch(errors => {
					this.$log.error('user register', 'auth.registerWithInvitation ERROR', errors)()
					this.form_error = errors
				})
		}
	},
	beforeCreate () {
		this.$title(this.$t('base.auth.signup'))
	},
	created () {
		if (this.email)
			this.model.email = this.email
	}
}
</script>



// WEBPACK FOOTER //
// src/components/auth/AuthRegisterWithInvitation.vue